export const iconFontAwesomeUsersPeoplePeopleGroup = (
	<i className="fa-solid fa-people-group"></i>
);
